import Vue from 'vue'
import API from '@/store/apiUtils'
import FIELD from '@/helpers/fieldHelper'
import {
  EA_EDITABLE_STATUSES
} from '@/constants'

const eaApplicationsModule = {
  state: {
    eaApplications: {},
    searchApplicationsFilter: '',
    eaApplicationOwnerApplications: []
  },      
  getters: {
    eaApplications: state => category => {
      return state.eaApplications[category]
        ? state.eaApplications[category]
        : []
    },
    searchApplicationsFilter: state => state.searchApplicationsFilter,
    isEaApplicationReadOnly: (_, getters) => {
      const application = getters.application
      return (
        application && 
        EA_EDITABLE_STATUSES.indexOf(application.applicationStatus) === -1
      )
    }
  },
  mutations: {
    setEaApplications(state, { category, applications }) {
      if (!state.eaApplications[category]) {
        // init the object
        Vue.set(state.eaApplications, category, [])
      }

      // map the data once here to avoid mapping on a computed prop in the view
      const applicationsMapped = applications.map(a => {
        // flatten application data
        const app = { ...a, ...a.application }
        app.name = app.client.lastName + ', ' + app.client.firstName
        return app
      })
      Vue.set(state.eaApplications, category, applicationsMapped)
    },
    setApplicationsFilter(state, value) {
      state.searchApplicationsFilter = value
    },
    setStatusFilter(state, value) {
      state.statusFilter = value
    },
    setStartDateFilter(state, value) {
      state.startDateFilter = value
    }

  },
  actions: {
    getEaApplications({ commit, getters }) {
      
      const category = getters.selectedCategory;
      if (!category) {
        return { clientApplications: [] }
      }

      const promises = []

      promises.push(
         API.get(
          `${process.env.VUE_APP_API_EA}/applications/submitted/${category}`,
          false,
          { category: category }
        ).then(res => {
          return res.data.clientApplications
        })
      )

      return Promise.all(promises).then(responses => {
        const applications = responses[0]
        commit('setEaApplications', {
          category: category,
          applications: applications
        })
      })
    },

    getEaApplication(store, [id]) {
      const apiUrl = `${process.env.VUE_APP_API_EA}/applications/submitted/retrieve/${id}`
      

      FIELD.setStore(store)


      return new Promise(done => {
        store.commit('set', ['isEditing', false])
        store.commit('set', ['application', null])

        store.dispatch('showSpinner')
        let apiHeaders = {}
        // Gets application record...
        API.get(apiUrl, true, apiHeaders).then(response => {
          let application = {}
          if( response.data.body.Items && response.data.body.Items.length > 0 ) {
             application = response.data.body.Items[0]
          }
          
          // API Mis-design: Deeper level, different keys
          // API Mis-design: `application` instead of `oesApplication`
          store.commit('set', ['application', application])
          store.commit('set', [
            'application.updatedBy',
            application.userId
          ])
          done()

          // let getReferenceData = store.dispatch('getReferenceData')

          // // Gets all reference data...
          // Promise.all([
          //   getReferenceData
          // ]).then(data => {
          //   let referenceData = data[0]

          //   store.commit('set', ['referenceData', referenceData])

          //   store.dispatch('displayApplication', response.data.body)
          //   store.dispatch('hideSpinner')

          //   done()
          // })
        })
      })
    },

    saveApplicationStatus(
      { getters, dispatch },
      { applicationStatus, comment, sendEmail, newDocuments }
    ) {
      const { applicationId } = getters.application
      //const apiUrl = `${process.env.VUE_APP_API_EA}/applications/submitted/retrieve/${id}`
      dispatch('set', ['application.applicationStatus', applicationStatus])

      const payload = {
        applicationStatus,
        comment,
        sendEmail,
        changeType: ["STATUS"],
        newDocuments
      }

      return API.put(
        `${process.env.VUE_APP_API_EA}/applications/submitted/retrieve/${applicationId}`,
        payload,
        false
      )
    },
   
  }
}

export default eaApplicationsModule
